import { Check } from "lucide-react";

export const ProgressSteps = ({ steps, current }) => {
  return (
    <div
      data-testid="progress-steps"
      className="flex items-center gap-2 sm:gap-4"
    >
      {steps.map((label, i) => {
        const isDone = i < current;
        const isActive = i === current;
        return (
          <div key={label} className="flex items-center gap-2 sm:gap-4">
            <div className="flex items-center gap-2">
              <span
                className={`h-7 w-7 inline-flex items-center justify-center rounded-full text-xs font-semibold border ${
                  isActive
                    ? "bg-slate-900 text-white border-slate-900"
                    : isDone
                      ? "bg-emerald-700 text-white border-emerald-700"
                      : "bg-white text-slate-500 border-slate-300"
                }`}
              >
                {isDone ? <Check size={14} /> : i + 1}
              </span>
              <span
                className={`hidden sm:inline text-sm ${isActive ? "text-slate-900 font-semibold" : "text-slate-500"}`}
              >
                {label}
              </span>
            </div>
            {i < steps.length - 1 && (
              <span className="h-px w-8 sm:w-12 bg-slate-300" />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ProgressSteps;
